import { ehDeciduo, parseDentes } from "@bookdental/schemas";
import { Arcada } from "./Arcada";

/** Proporção do desenho da arcada permanente (viewBox 409×694, superior em cima, inferior embaixo). */
const LARGURA = 409;
const METADE = 347;

/** Dentes de um item já salvo: a arcada permanente se houver permanente, a decídua se houver decíduo
 *  (as duas lado a lado na dentição mista). Texto livre sem dente reconhecido vira só o texto.
 *  `soArcadaUsada`: com dentes só em cima (ou só embaixo), mostra só essa metade — no mesmo espaço
 *  o desenho fica do dobro do tamanho. */
export function ArcadaSomenteLeitura({
  dentes,
  largura = 180,
  soArcadaUsada = false,
}: {
  dentes: string | null | undefined;
  largura?: number;
  soArcadaUsada?: boolean;
}) {
  const lista = parseDentes(dentes);
  if (lista.length === 0) return <p className="text-sm text-zinc-700 dark:text-foreground/80">{dentes || "—"}</p>;
  const permanentes = lista.filter((d) => !ehDeciduo(d));
  const temDeciduo = lista.some(ehDeciduo);
  const superior = permanentes.some((d) => d.startsWith("1") || d.startsWith("2"));
  const inferior = permanentes.some((d) => d.startsWith("3") || d.startsWith("4"));
  const recorte = soArcadaUsada && superior !== inferior ? (superior ? "superior" : "inferior") : null;
  const arcada = <Arcada denticao="permanente" selecionados={lista} somenteLeitura />;

  return (
    <div className="flex flex-wrap gap-3">
      {permanentes.length > 0 && (
        <div className="w-full" style={{ maxWidth: largura }}>
          {recorte ? (
            <div className="overflow-hidden" style={{ aspectRatio: `${LARGURA} / ${METADE}` }} title={`Arcada ${recorte}`}>
              {/* margem em % é da largura: subir a metade de cima deixa só a inferior à vista. */}
              <div style={{ marginTop: recorte === "inferior" ? `-${((METADE / LARGURA) * 100).toFixed(2)}%` : 0 }}>{arcada}</div>
            </div>
          ) : (
            arcada
          )}
        </div>
      )}
      {temDeciduo && (
        <div className="w-full" style={{ maxWidth: largura }}>
          <Arcada denticao="decidua" selecionados={lista} somenteLeitura />
        </div>
      )}
    </div>
  );
}
